import {Text, View} from '@react-pdf/renderer'
import {styles} from './Styles'

export const Chip = (chipValue) => {
  const {label, type, values} = chipValue

  // Determine the text based on the chip type
  const text = (() => {
    switch (type) {
      case 'checkbox':
      case 'toggle':
        return values ? `${label}: ${values}` : label
      case 'range':
        return `${label}: ${values?.min} - ${values?.max}`
      default:
        return label
    }
  })()

  return (
    <View key={text} style={styles.chip}>
      <Text style={styles.textRegular}>{text}</Text>
    </View>
  )
}

/**
 * List of functions and their purpose:
 *
 * - chip: Renders a styled chip component for PDF layouts, displaying label and values based on the chip type.
 */
